<template>
  <div>
    <div class="flex items-center space-x-4">
      <router-link :to="{ name: 'tagsIndex' }" class="system-button">
        <arrow-icon class="w-4 rotate-90"></arrow-icon>
      </router-link>
      <h2>{{ isEditing ? "Editar" : "Crear" }} Etiqueta</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form @submit.prevent="save">
        <div class="flex flex-col w-full">
          <label for="name">Nombre</label>
          <input id="name" type="text" v-model="form.name" />
          <validation-errors :errors="errorFor('name')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-4">
          <label for="slug">Slug</label>
          <input
            id="slug"
            type="text"
            v-model="form.slug"
            class="font-mono"
            placeholder="se genera automáticamente si lo dejas vacío"
          />
          <validation-errors :errors="errorFor('slug')"></validation-errors>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}</primary-button
        >
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Tag Form",

  data() {
    return {
      form: { name: "", slug: "" },
      loading: false,
      loadingForm: false,
      isEditing: false,
    };
  },

  mixins: [validationErrors],

  created() {
    this.$store.commit("setStoreSelectedTab", "tags");

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadTag();
    }
  },

  methods: {
    async loadTag() {
      this.loading = true;

      try {
        const tag = await api.tags.getById(this.$route.params.id);
        this.form = { name: tag.name, slug: tag.slug };
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createTag();
      } else {
        this.updateTag();
      }
    },

    validateForm() {
      this.errors = {};
      if (!this.form.name) this.errors["name"] = ["Campo requerido"];
      return Object.keys(this.errors).length === 0;
    },

    payload() {
      const out = { ...this.form };
      if (!out.slug) delete out.slug;
      return out;
    },

    async createTag() {
      this.loadingForm = true;
      try {
        const response = await api.tags.create(this.payload());
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "tagsIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
      this.loadingForm = false;
    },

    async updateTag() {
      this.loadingForm = true;
      try {
        const response = await api.tags.update(
          this.$route.params.id,
          this.payload()
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "tagsIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
      this.loadingForm = false;
    },
  },
};
</script>
